import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConditionsComponent } from '../../components/conditions/conditions.component';
@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FaqComponent implements OnInit {

  componentDestroyed$: Subject<boolean> = new Subject();
  
  constructor(public translate: TranslocoService, public dialog: MatDialog,) { }

  ngOnInit(): void {
  }

  public openConsent() {
    const dialogRef = this.dialog.open(ConditionsComponent, {
      disableClose: false,
      data: true
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(data => {
        console.log(data);
      });
  }

}
